let product;
window.addEventListener("load", (event) => {
    let bundle_components = document.querySelectorAll(".bundle_component");
    bundle_components.forEach(bundle_component => {
        product = new Product(bundle_component)
    })
    let atc = product.element.closest(".bundle_products").querySelector(".ProductForm__AddToCart")
    if (atc != null) {
        atc.addEventListener("click", ({target}) => {
            product.addToCart(target)
        })
    }
})
class Product {
    constructor(bundle_component) {
        let _this = this
        this.element = bundle_component
        let jsonData = JSON.parse(
            this.element.querySelector('[data-product-json]').innerHTML
        )
        this.selectedVariant = +this.element.querySelector("input.component_variantID").value
        this.productData = jsonData['product']
        this.name = this.productData.title
        this.productData.variants.forEach(variant => {
            if (variant['id'] === _this.selectedVariant) {
                _this.currentVariant = variant
                _this.option1 = variant['option1']
                _this.option2 = variant['option2']
                _this.option3 = variant['option3']
            }
        })
        this.currentVariant = this.getCurrentVariantFromOptions()
        this.attachListeners()
        this.selectOptions()
    }
    attachListeners() {
        let _this3 = this
        this.element.querySelectorAll('.product_options [type="radio"]').forEach(radioButton => {
            radioButton.addEventListener("change", ({target}) => {
                _this3.onOptionChanged(target)
            })
        })
    }
    selectOptions() {
        let colors = this.element.querySelectorAll("[data-option-name='color'] input");
        let title = this.element.querySelectorAll("[data-option-name='title'] input");
        if (title.length > 0) {
            title[0].click()
        }
        if (colors.length == 1) {
            colors[0].click()
            this.element.querySelector(".ColorSwatchList").style.display = "none"
        }
    }
    onOptionChanged(target) {
        this[`option${target.getAttribute('data-option-position')}`] = target.value
        const selectedValue = target.closest('.product_option').querySelector('.ProductForm__SelectedValue');
        let labelText = target.closest('.product_option').querySelector('.ProductForm__Name')
        labelText.innerText = labelText.innerText.replace("Select ", "Selected ")
        if (selectedValue) {
            selectedValue.innerHTML = target.value
        }
        this.currentVariant = this.getCurrentVariantFromOptions()
        if (this.currentVariant) {
            if (this.currentVariant.featured_image != null) {
                this.element.querySelector(".featured_image img").src = this.currentVariant.featured_image.src
            }
            this.element.querySelector("input.component_variantID").value = this.currentVariant.id
            this.selectedVariant = this.currentVariant.id
            this.available = this.currentVariant.available
            this.element.querySelector("input.component_variantID").dataset.option1 = this.option1
            this.element.querySelector("input.component_variantID").dataset.option2 = this.option2
            this.element.querySelector("input.component_variantID").dataset.option3 = this.option3
            this.element.querySelector("input.component_variantID").dataset.available = this.currentVariant.available
            target.closest(".product_option").querySelector(".ProductForm__Name").classList.remove("select_error")
        }
        let isColorSwatch = target.classList.contains("ColorSwatch__Radio")
        if (isColorSwatch) {
            this.resetSizes(target)
            this.checkSizeInventory(target)
        }
    }
    getCurrentVariantFromOptions() {
        const _this2 = this;
        let found = false;
        this.productData['variants'].forEach(variant => {
            if (
                variant['option1'] === _this2.option1 &&
                variant['option2'] === _this2.option2 &&
                variant['option3'] === _this2.option3
            ) {
                found = variant
            }
        })
        return found || null
    }
    checkSizeInventory(element) {
        let this_4 = this
        let color = element.value
        let sizes = element.closest(".product_options").querySelector(".product_option[data-option-name='size']")
        if (sizes) {
            sizes.querySelectorAll(".SizeSwatch__Radio").forEach(size => {
                let found = false;
                this_4.productData['variants'].forEach(variant => {
                    if (variant['option1'] === color && variant['option2'] === size.value && variant['option3'] === null) {
                        found = variant
                    }
                });
                if (found.available) {
                    size.disabled = false
                } else {
                    size.disabled = true
                }
            });
        };
    }
    resetSizes(target) {
        let selectedSize = target.closest(".product_options").querySelector(".SizeSwatch__Radio:checked")
        let sizeLabelText = target.closest(".product_options").querySelector("[data-option-name='size'] .ProductForm__Name")
        let sizeLabelValue = target.closest(".product_options").querySelector("[data-option-name='size'] .ProductForm__SelectedValue")
        if (selectedSize) {
            sizeLabelText.innerText = sizeLabelText.innerText.replace("Selected", "Select")
            sizeLabelValue.innerText = ""
            selectedSize.checked = false
        }
    }
    checkVariantsSelected() {
        let bundle_components = document.querySelectorAll(".bundle_component");
        let optionsSelected = [];
        bundle_components.forEach(bundle_component => {
            let available = JSON.parse(bundle_component.querySelector(".component_variantID").dataset.available);
            let product_options = bundle_component.querySelectorAll(".product_option");
            product_options.forEach(product_option => {
                if (product_option.querySelectorAll("input:checked").length == 0) {
                    let product_option_name = product_option.dataset.optionName
                    product_option.querySelector(".ProductForm__Name").classList.add("select_error")
                    this.errorMessage(product_option, product_option_name)
                    optionsSelected.push(false)
                } else {
                    optionsSelected.push(true)
                }
            })
        })
        if (optionsSelected.includes(false)) {
            return false
        } else {
            return true
        }
    }
    errorMessage(product_option, product_option_name) {
        let atcbutton = document.querySelector(".bundle_product_button");
        let title = product_option.closest("[data-title]").dataset.title;
        let errorMessageElement = document.createElement('span');
        errorMessageElement.className = 'ProductForm__Error Alert Alert--error'
        errorMessageElement.innerHTML = `Select ${product_option_name} for ${title}`
        atcbutton.insertAdjacentElement(
            'afterend',
            errorMessageElement
        )
        setTimeout(() => {
            errorMessageElement.remove()
        }, 5000)
    }
    addToCart(target) {
        let cartJSON = {
            items: []
        }
        let bundle_components = target.closest(".bundle_products").querySelectorAll("input.component_variantID")
        bundle_components.forEach(({value}) => {
            cartJSON.items.push({
                quantity: 1,
                id: value
            })
        })
        let optionSelected = this.checkVariantsSelected()
        if (optionSelected) {
            fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(cartJSON)
            }).then(response => {
                document.dispatchEvent(new CustomEvent('theme:loading:end'))
                if (response.ok) {
                    document.dispatchEvent(
                        new CustomEvent('product:added', {
                            bubbles: true,
                            detail: {
                                variant: 1,
                                quantity: 1
                            }
                        })
                    )
                } else {
                    if (!response.ok) {
                        document.querySelector(".ProductForm__AddToCart").insertAdjacentHTML("afterend", '<div class="retry_message">One or more items is out of stock, please try again</div>')
                        setTimeout(() => {
                            const retry_message = document.querySelector(".retry_message")
                            if (retry_message) {
                                retry_message.remove()
                            }
                        }, 5000)
                    }
                }
                return response.json()
            }).catch(error => {
                console.error('Error:', error)
            })
        }
    }
}
